import { v4 as uuidv4 } from "uuid";

export enum NewsletterTypes{
  Reporting = 'Reporting',
  Events = 'Events'
}

export enum FamilyNewsletterOptionsEnum {
  ConciergeEventsAttended = 'Concierge events attended',
  LifestyleEventsAttended = 'Lifestyle events attended',
  VideoCalls = 'Video Calls',
  FriendsAdded = 'Friends added',
  NewServicesBooked = 'New Services booked',
  IncludeAttendedEventsList = 'Include attended events list',
  IncludeAttendedEventsGallery = 'Include attended events gallery'
}

export const familyNewsletterOptions = [
  { id: uuidv4(), name: FamilyNewsletterOptionsEnum.ConciergeEventsAttended, type: NewsletterTypes.Reporting, status: true },
  { id: uuidv4(), name: FamilyNewsletterOptionsEnum.LifestyleEventsAttended, type: NewsletterTypes.Reporting, status: true },
  { id: uuidv4(), name: FamilyNewsletterOptionsEnum.VideoCalls, type: NewsletterTypes.Reporting, status: true },
  { id: uuidv4(), name: FamilyNewsletterOptionsEnum.FriendsAdded, type: NewsletterTypes.Reporting, status: true },
  { id: uuidv4(), name: FamilyNewsletterOptionsEnum.NewServicesBooked, type: NewsletterTypes.Reporting, status: true },
  { id: uuidv4(), name: FamilyNewsletterOptionsEnum.IncludeAttendedEventsGallery, type: NewsletterTypes.Events, status: true },
  { id: uuidv4(), name: FamilyNewsletterOptionsEnum.IncludeAttendedEventsList, type: NewsletterTypes.Events, status: true },
]